import { Tab } from "@mui/material";
import { MprcBarTabs, MprcContainer } from "components";
import { useTranslation } from "react-i18next";
import { TrainingPanelTabOptions } from "views/dashboard/TrainingPanel/shared";

interface IProps {
    selectedOption: TrainingPanelTabOptions;
    onIndicatorClick?: () => void;
    onAnalyseClick?: () => void;
}

export const MainOptions = ({ selectedOption, onAnalyseClick, onIndicatorClick }: IProps) => {
    const { t } = useTranslation("dashboard");

    return <MprcContainer>
        <MprcBarTabs value={selectedOption} size="large">
            <Tab value="indicator" label={t("TrainingPanel.Tabs.Indicators")} sx={{ minWidth: 250 }} onClick={onIndicatorClick} />
            <Tab value="analyse" label={t("TrainingPanel.Tabs.Analysis")} sx={{ minWidth: 250 }} onClick={onAnalyseClick} />
        </MprcBarTabs>
    </MprcContainer>;
};
